<template>
  <div class="boxbgcolor">
    <div class="left content-left">
      <!-- <StationTree ref='stationTree' v-on:handleTreeClick='handleTreeClick'></StationTree> -->
      <GatewayTree ref="areaTree" :moduleName="moduleName" v-on:handleTreeClick="handleTreeClick"></GatewayTree>
    </div>
    <div class="content-right">
      <div class="list">
        <div class="searchbox">
          <form action="#" method="get" class="form-inline form-float">
            <div class="form-group">
              <label for>地磁编号</label>
              <input v-model="search.devNum" placeholder="地磁编号" v-noBlankSpace class="form-control" />
            </div>
            <div class="form-group">
              <label for>地磁状态</label>
              <el-select clearable v-model="search.devStatu" placeholder="请选择">
                <el-option
                  v-for="item in devStatus"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div class="form-group others">
              <span class="search_btn">
                <button @click="searchList" type="button" class="btn btn-primary" id="search_btn">查询</button>
              </span>
              <span class="add_btn">
                <button
                  v-if="devManger_btn_add"
                  type="button"
                  class="btn btn-default"
                  id="addarea"
                  @click="addOrEdit()"
                >添加</button>
              </span>
              <!--<button @click="clearSearch" type="button" class="btn btn-default">清空</button>-->
              <!-- <span class='refresh_btn'><Refresh @tableList="this.tableList"></Refresh></span> -->
            </div>
          </form>
        </div>
        <div class="list-right">
          <el-table
            ref="table"
            border
            :data="tableListData.rows"
            height="100%"
            :header-cell-style="tableHeaderStyle"
            :cell-style="styleObj"
          >
            <el-table-column label="地磁编号" prop="onerankdevDevSn"></el-table-column>
            <el-table-column label="网关编号" prop="attr7"></el-table-column>
            <el-table-column label="泊位编号" prop="attr4"></el-table-column>
            <el-table-column label="最后通讯时间" prop="lastFlowDate"></el-table-column>
            <el-table-column label="地磁状态" prop="attr1">
              <template slot-scope="scope">{{scope.row.attr1|status}}</template>
            </el-table-column>
            <el-table-column label="剩余电量(%)">
              <template slot-scope="scope">
                <div class="electricity">
                  <div class="battery">
                    <canvas width="20" height="10" :id="scope.row.devId" class="show_pow"></canvas>
                    <canvas width="5" height="5" :id="scope.row.devId+'s'" class="pow_head"></canvas>
                  </div>
                  <div>{{!scope.row.pow?'':scope.row.pow}}</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="通信频率" prop="loraid"></el-table-column>
            <el-table-column label="是否校准">
              <template slot-scope="scope">
                <el-checkbox
                  v-if="scope.row.record==true&&scope.row.wave==true"
                  checked
                  @change="correct({id:scope.row.devId,record:'false',wave:'false'})"
                >校准</el-checkbox>
                <el-checkbox
                  v-else
                  @change="correct({id:scope.row.devId,record:'true',wave:'true'})"
                >校准</el-checkbox>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="200px">
              <template slot-scope="scope">
                <button
                  class="edit"
                  v-if="devManger_btn_edit"
                  type="button"
                  @click="addOrEdit(scope.row.devId)"
                >修改</button>
                <button
                  class="delete"
                  v-if="devManger_btn_remove"
                  @click="del(scope.row.devId)"
                  type="button"
                >删除</button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>

    <!-- <Page :pageSize="search.pageSize" v-on:tableList='tableList'></Page>	 -->

    <Page v-on:pagination="receivePaginationData"></Page>
    <!--添加/修改地磁-->
    <el-dialog
      ref="park"
      title="添加/修改地磁"
      :close-on-click-modal="false"
      :lock-scroll="false"
      :visible.sync="dialogFormVisible"
      width="430px"
      @open="openDialog"
      @close="closeDialog"
    >
      <el-form :model="editOrAddForm" :rules="editOrAddFormRules" ref="editOrAddFormV">
        <el-form-item label="地磁编号" :label-width="formLabelWidth" prop="devNum">
          <el-col :span="18">
            <el-input v-model="editOrAddForm.devNum"></el-input>
          </el-col>
        </el-form-item>
        <!--<el-form-item label="泊位编号" :label-width="formLabelWidth" prop='spaceNum'>
				<el-input v-model="editOrAddForm.spaceNum"></el-input>
        </el-form-item>-->
        <!-- <el-form-item  label="网关编号" :label-width="formLabelWidth" prop='stationSn'>
				
					<el-col :span="18">
						<el-select filterable clearable v-model="editOrAddForm.stationId" placeholder="请选择" @change="selectStation">
								<el-option
								v-for="item in allStations.rows"
								:key="item.stationId"
								:label="item.stationSn"
								:value="item.stationId">
								</el-option>
						</el-select>
					</el-col>	
        </el-form-item>-->
        <el-form-item label="通信频率" :label-width="formLabelWidth" prop="loraid">
          <el-col :span="18">
            <el-input v-model="editOrAddForm.loraid"></el-input>
          </el-col>
        </el-form-item>

        <!-- <el-form-item  ref="road" label="停车道路" :label-width="formLabelWidth" prop='parkingName'  >
			
					<el-col :span="18">
						<el-select   clearable filterable v-model="editOrAddForm.parkingName" placeholder="请选择" @change="selectPark">
								<el-option 
								v-for="item in tableListParkDataAll.rows"
								:key="item.parkingId"
								:label="item.parkingName"
								:value="item.parkingId">
								</el-option>
						</el-select>
					</el-col>	
				</el-form-item>
				<el-form-item  label="泊位段" :label-width="formLabelWidth" prop='areaName'>
				
					<el-col :span="18">
						<el-select filterable  clearable v-model="editOrAddForm.areaName"  placeholder="请选择" @change="selectArea">
							<el-option
							v-for="item in tableListAreaDataAll.arealist" 

							:key="item.areaId"
							:label="item.areaName"
							:value="item.areaId">
							</el-option>
						</el-select>
					</el-col>	
        </el-form-item>-->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addOrEditTrue">确 定</el-button>
        <el-button @click="dialogFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import {
  greater50,
  correct,
  getAllStationList,
  allEquipStatus,
  delEquip,
  editEquip,
  getAllEquipList,
  getAllDatas,
  getAllParkingsByEnabled,
  addEquip,
  getOneEquip,
  getEquipList,
  getAllStatusList,
  getStatusList,
  dictValue,
  getOrderList,
} from "@/api/url";
import StationTree from "./components/stationTree.vue";
import Page from "../../commons/page";

// import Refresh from "../commons/refresh.vue";
import GatewayTree from "../../commons/gatewayTree";
export default {
  data() {
    return {
      dialogFormVisible: false,
      devManger_btn_edit: false,
      devManger_btn_remove: false,
      devManger_btn_add: false,
      isChecked: true,
      park: "",
      treeData: {
        parentId: "",
      },
      // stationData:{
      // 	stationId:''
      // },
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      tableListParkDataAll: {},
      tableListAreaDataAll: {},
      allStations: {},
      editOrAddForm: {
        devId: "",
        devNum: "",
        stationId: "",
        stationSn: "",
        // spaceNum:'',
        // parkingName:'',
        // areaName:'',
        // spaceId:'',
        // parkingId:'',
        // areaId:'',
        loraid: "",
      },
      devStatus: [
        { name: "正常", value: "normal" },
        { name: "异常", value: "error" },
      ],
      editOrAddFormRules: {
        devNum: [
          { required: true, message: "请填写地磁编号", trigger: "blur" },
        ],
        spaceNum: [
          { required: true, message: "请填写泊位编号", trigger: "blur" },
        ],
        parkingName: [
          { required: true, message: "请填写停车道路", trigger: "blur" },
        ],
        // areaName: [
        //     { required: true, message: '请填写泊位段', trigger: 'blur' },
        // ],
        stationSn: [
          { required: true, message: "请选择基站编号", trigger: "blur" },
        ],
      },
      formLabelWidth: "100px",
      allOrderType: [],
      moduleName: "",
      temp: [],
      search: {
        pageNumber: 1,
        pageSize: 10,
        devStatu: "",
        devNum: "",
        //transNum:'',
        //startTime:"",
        //endTime:""
      },
      downloadFileds: {
        地磁编号: "onerankdevDevSn",
        网关编号: {
          field: "attr7",
          callback: (value) => {
            return value != "" && value != undefined
              ? JSON.parse(value).stationSn
              : "";
          },
        },
        泊位编号: {
          field: "attr8",
          callback: (value) => {
            return value != "" && value != undefined
              ? JSON.parse(value).spaceNum
              : "";
          },
        },
        停车道路: {
          field: "attr2",
          callback: (value) => {
            return value != "" && value != undefined
              ? JSON.parse(value).parkingName
              : "";
          },
        },
        泊位段: {
          field: "attr3",
          callback: (value) => {
            return value != "" && value != undefined
              ? JSON.parse(value).areaName
              : "";
          },
        },
        最后通讯时间: "lastFlowDate",
        地磁状态: "attr1",
        通信频率: "loraid",
      },
      tableListData: {
        rows: [],
      },
      tableListDataAll: {},
    };
  },
  filters: {
    status(value) {
      var resultValue = "";
      switch (value) {
        case "error":
          resultValue = "异常";
          break;
        case "异常":
          resultValue = "异常";
          break;
        case "normal":
          resultValue = "正常";
          break;
        case "正常":
          resultValue = "正常";
          break;
        default:
          break;
      }
      return resultValue;
    },
  },
  methods: {
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      this.tableList(this.search.pageNumber);
    },
    handleTreeClick: function (node, data) {
      this.search.devStatu = "";
      this.search.devNum = "";
      if (node.type != "station") {
        this.treeData.parentId = "";
        this.tableListData.rows = [];
        var pageObj = {
          curIndex: 1,
          rowsCount: 0,
        };
        this.getPage(pageObj);
        // this.$message({
        // 	type:'warning',
        // 	message:'请选择网关'
        // })
        return;
      } else {
        this.treeData.parentId = node.id;
        this.search.pageNumber = 1;
        this.tableList(this.search.pageNumber);
      }
    },

    getOrderType: function () {
      this.$get(dictValue() + "/order_type").then((data) => {
        this.allOrderType = data.data.rows;
      });
    },
    tableList: function (curPage) {
      var _this = this;
      this.$get(getEquipList(), {
        stationId: this.treeData.parentId,
        onerankdevDevStatus: this.search.devStatu,
        onerankdevDevSn: this.search.devNum,
        // stationId:this.stationData.stationId,
        onerankdevDevType: 212,
        limit: this.search.pageSize,
        page: curPage,
        //beginTime:this.search.startTime,
        //endTime:this.search.endTime,
        //onerankdevDevSn:this.search.devNum,
        //transNum:this.search.transNum
      }).then((data) => {
        if (data.status != 200) return;
        //翻页
        var pageObj = {
          curIndex: data.data.offset,
          rowsCount: data.data.total,
        };
        _this.getPage(pageObj);
        _this.tableListData.rows = data.data.rows;
        _this.$nextTick(this.canvasPow);
        _this.$nextTick(() => {
          _this.$refs.table.doLayout();
        });
      });
    },
    canvasPow() {
      var _this = this;
      for (let item of _this.tableListData.rows) {
        var canvas = document.getElementById(item.devId);
        var context = canvas.getContext("2d");
        context.clearRect(0, 0, 20, 10);
        var pow = item.pow || 0;
        if (pow >= 80) {
          canvas.style = "border:1px solid #696969";
          context.fillStyle = "green";
        } else if (pow >= 40 && pow < 80) {
          canvas.style = "border:1px solid #696969";
          context.fillStyle = "#FF6100";
        } else if (pow < 40 && pow > 0) {
          canvas.style = "border:1px solid red";
          context.fillStyle = "red";
        } else {
          canvas.style = "border:1px solid red";
          context.fillStyle = "";
        }
        context.fillRect(0, 0, (20 / 100) * parseInt(pow), 10);
        var canvas1 = document.getElementById(item.devId + "s");
        var context1 = canvas1.getContext("2d");
        context1.fillStyle = "#696969";
        context1.fillRect(0, 0, 5, 5);
      }
    },
    tableListAll: function () {
      var _this = this;
      this.$get(getAllEquipList()).then((data) => {
        //if(data.status!=200) return _this.$layer.msg(data.message);
        this.tableListDataAll = data.data;
      });
    },

    correct(cor) {
      this.$postRequest(correct(), {
        devId: cor.id,
        recordStatus: cor.record,
        waveStatus: cor.wave,
        resetStatus: "false",
        upgradeStatus: "false",
      }).then((data) => {
        if (data.status != 200) return;
        this.$notify({
          title: "成功",
          message: "操作成功!",
          type: "success",
        });
        this.tableList(this.curIndex);
      });
    },

    tableListParkAll: function () {
      this.$get(getAllParkingsByEnabled()).then((data) => {
        if (data.status != 200) return _this.$layer.msg(data.message);
        // var rows = data.data.rows;
        // for(var i in rows){
        // }
        //console.log("tableListDataAll")
        //console.log(this.tableListData.rows)
        this.tableListParkDataAll = data.data;
      });
    },
    getAllStations() {
      this.$get(getAllStationList()).then((data) => {
        if (data.status != 200) return;
        this.allStations = data.data;
      });
    },
    // selectPark(value){

    // 	this.editOrAddForm.areaName='';
    // 	this.editOrAddForm.areaId='';
    // 	this.editOrAddForm.parkingId=value;

    // },
    // selectArea(value){

    // 	this.editOrAddForm.areaId=value;

    // },

    // showAllPark(e){

    // 		this.tableListParkAll();

    // },
    // showAllArea(e){

    // 	if(!e)
    // 		this.tableListAreaAll(this.editOrAddForm.parkingId);

    // },
    selectStation(value) {
      this.editOrAddForm.stationSn = value;
      this.$get(greater50(), {
        stationId: value,
      }).then((data) => {
        // console.log(data)
        if (data.status == "30101") {
          this.dialogFormVisible = false;
          // console.log(this.dialogFormVisible)
          //   this.$notify.error({
          // 	title: '失败',
          // 	message: '网关最大连接数已达到50'
          // 	});
        }
      });
      // console.log(value)
    },

    addOrEdit(id) {
      this.dialogFormVisible = true;
      if (!id) {
        if (!this.treeData.parentId) {
          this.$message({
            type: "warning",
            message: "请选择网关",
          });
          this.dialogFormVisible = false;
          return;
        }
        this.tableListAreaDataAll = {};
        this.editOrAddForm.devId = "";
        this.editOrAddForm.devNum = "";
        this.editOrAddForm.spaceNum = "";
        this.editOrAddForm.stationId = "";
        this.editOrAddForm.stationSn = "";
        // this.editOrAddForm.parkingName='';
        // this.editOrAddForm.areaName='';
        // this.editOrAddForm.parkingId='';
        // this.editOrAddForm.areaId='';
        this.editOrAddForm.loraid = "";
      } else {
        // console.log("修改了")
        this.$get(getOneEquip(), {
          devId: id,
        }).then((data) => {
          if (data.status != 200) return _this.$layer.msg(data.message);
          this.editOrAddForm.devId = id;
          this.editOrAddForm.devNum = data.data.onerankdevDevSn;
          this.editOrAddForm.stationId =
            data.data.attr7 != "" && data.data.attr7 != undefined
              ? JSON.parse(data.data.attr7).stationId
              : "";
          this.editOrAddForm.stationSn =
            data.data.attr7 != "" && data.data.attr7 != undefined
              ? JSON.parse(data.data.attr7).stationSn
              : "";
          // this.editOrAddForm.spaceNum=data.data.attr8!=""&&data.data.attr8!=undefined?JSON.parse(data.data.attr8).spaceNum:'';
          // this.editOrAddForm.parkingName=data.data.attr2!=""&&data.data.attr2!=undefined?JSON.parse(data.data.attr2).parkingName:'';
          // this.editOrAddForm.areaName=data.data.attr3!=""&&data.data.attr3!=undefined?JSON.parse(data.data.attr3).areaName:'';
          // this.editOrAddForm.spaceId=data.data.attr8!=""&&data.data.attr8!=undefined?JSON.parse(data.data.attr8).spaceId:'';
          // this.editOrAddForm.parkingId=data.data.attr2!=""&&data.data.attr2!=undefined?JSON.parse(data.data.attr2).parkingId:'';
          // this.editOrAddForm.areaId=data.data.attr3!=""&&data.data.attr3!=undefined?JSON.parse(data.data.attr3).areaId:'';
          this.editOrAddForm.loraid = data.data.loraid;
          // this.tableListAreaAll(this.editOrAddForm.parkingId);
          // console.log(this.tableListAreaDataAll)
        });
      }
    },
    addOrEditTrue() {
      var _this = this;
      this.$refs["editOrAddFormV"].validate(function (valid, noStri) {
        if (valid) {
          _this.dialogFormVisible = false;
          if (!_this.editOrAddForm.devId) {
            _this
              .$postRequest(
                addEquip() + "?stationId=" + _this.treeData.parentId,
                {
                  onerankdevDevSn: _this.editOrAddForm.devNum,
                  loraid: _this.editOrAddForm.loraid,
                  stationId: _this.treeData.parentId,
                  //spaceNum:_this.editOrAddForm.spaceNum,
                  // attr2:_this.editOrAddForm.parkingId,
                  // attr3:_this.editOrAddForm.areaId
                }
              )
              .then((data) => {
                if (data.status != 200) return _this.$layer.msg(data.message);
                _this.$notify({
                  type: "success",
                  message: "添加成功！",
                  title: "成功",
                });
                _this.search.pageNumber = 1;
                _this.tableList(_this.search.pageNumber);
              });
          } else {
            _this
              .$putRequest(
                editEquip() + "?stationId=" + _this.treeData.parentId,
                {
                  onerankdevDevSn: _this.editOrAddForm.devNum,
                  loraid: _this.editOrAddForm.loraid,
                  devId: _this.editOrAddForm.devId,
                  stationId: _this.treeData.parentId,
                  // attr2:_this.editOrAddForm.parkingId,
                  // attr3:_this.editOrAddForm.areaId
                }
              )
              .then((data) => {
                if (data.status !== 200) return _this.$layer.msg(data.message);
                _this.$notify({
                  type: "success",
                  message: "修改成功！",
                  title: "成功",
                });
                _this.tableList(_this.curIndex);
              });
          }
        }
      });
    },
    openDialog: function () {},
    closeDialog: function () {
      this.$refs["editOrAddFormV"].resetFields();
    },
    del: function (id) {
      var _this = this;
      // console.log(id)
      var index = _this.$layer.confirm(
        "您确定删除该设备吗？",
        {
          btn: ["确定", "取消"],
          shade: false,
          type: 0,
        },
        function () {
          _this.$layer.close(index);
          // console.log("222")
          _this.$deleteRequest(delEquip() + "?devId=" + id, {}).then((data) => {
            if (data.status != 200) return _this.$layer.msg(data.message);

            _this.$notify({
              type: "success",
              message: "删除成功！",
              title: "成功",
            });
            _this.tableList(_this.curIndex);
          });
        }
      );
    },
    allStatus() {
      this.$get(allEquipStatus()).then((data) => {
        if (status != 200) return;
        // console.log(data)
      });
    },
    searchList: function () {
      // var flTime=this.timeCompare(this.search.startTime,this.search.endTime);
      // // console.log(this.search.endTime)
      // if(flTime){
      // 	return this.$layer.msg('开始时间请勿大于结束时间', { time: 1});
      // }else if(!Boolean(this.search.startTime)&&Boolean(this.search.endTime)){
      // 	return this.$layer.msg('请选择开始时间', { time: 1});
      // }else if(Boolean(this.search.startTime)&&!Boolean(this.search.endTime)){
      // 	return this.$layer.msg('请选择结束时间', { time: 1});
      // }
      if (!this.treeData.parentId) {
        this.$message({
          type: "warning",
          message: "请选择网关",
        });
        return;
      }
      this.search.pageNumber = 1;
      this.tableList(this.search.pageNumber);
    },
    // timeCompare:function(bDateVal,eDateVal){
    // 	// console.log(bDateVal,eDateVal);

    // 	if(!Boolean(bDateVal)||!Boolean(eDateVal)){
    // 		return false;
    // 	}

    // 	var bdate = new Date(Date.parse(bDateVal.replace(/-/g, "/")));
    // 	bdate = bdate.getTime();
    // 	var edate = new Date(Date.parse(eDateVal.replace(/-/g, "/")));
    // 	edate = edate.getTime();
    // 	if(bdate-edate>0){
    // 		return true;
    // 	}else{
    // 		return false;
    // 	}
    // },
    clearSearch: function () {
      this.search.pageNumber = "1";
      this.search.type = "";
      this.search.startTime = "";
      this.search.endTime = "";
      this.search.devNum = "";
    },
  },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
    }),
    ...mapGetters(["elements"]),
    permiss() {
      this.devManger_btn_edit = this.elements["devManger:btn_edit"];
      this.devManger_btn_remove = this.elements["devManger:btn_remove"];
      this.devManger_btn_add = this.elements["devManger:btn_add"];
    },
  },

  components: {
    Page,
    StationTree,
    GatewayTree,
  },
  created: function () {
    //this.getOrderType();
  },
  mounted: function () {
    this.permiss;
    // this.tableList(this.search.pageNumber);
    // this.tableListAll();
    // this.tableListParkAll();
    this.allStatus();
    this.getAllStations();
    this.park = this.$refs.park;

    // console.log(this.$refs.park)
  },
  watch: {
    elements: {
      handler: function (val, oldVal) {
        this.permiss;
      },
      deep: true, //深度
    },
    "editOrAddForm.parkingId"(val) {
      this.tableListAreaAll(val);
    },
  },
};
</script>

<style scoped>
/* @import '@/assets/css/equip.css'; */
.modal-body .tab-img li {
  width: 100px;
  height: 100px;
  margin: 10px 10px;
}

.btns {
  margin: 20px auto 0;
  width: 150px;
}

table td label {
  margin-bottom: 0 !important;
}
.show_pow {
  border: 1px solid #696969;
  border-radius: 2px;
}
.pow_head {
  border-radius: 1px;
}
.boxbgcolor {
  display: flex;
}
.battery {
  width: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
}
.electricity {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
